import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  dragZone: {
    height: '100%',
  },
}));
